import { createContext } from "react";

interface LayoutContextValue {
  isDropZoneOpen: boolean;
}

export const LayoutContext = createContext<LayoutContextValue>({ isDropZoneOpen: false });
